import { render, staticRenderFns } from "./createSalaryStructure.vue?vue&type=template&id=b866f920&scoped=true"
import script from "./createSalaryStructure.vue?vue&type=script&lang=js"
export * from "./createSalaryStructure.vue?vue&type=script&lang=js"
import style0 from "./createSalaryStructure.vue?vue&type=style&index=0&id=b866f920&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b866f920",
  null
  
)

export default component.exports